import React,{ useState, useEffect,useRef } from 'react'
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { changeMessageSubmissionStatus, getSpecificMessageSubmissions } from '../../api/axiosMessageSubmissions';
import ProcessDiscard from '../../components/buttonActions/ProcessDiscard';
import { Toast } from 'primereact/toast';
import { AllToasts } from '../../components/Toasts/AllToasts';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';  
import { Tag } from 'primereact/tag';
import { useNavigate } from 'react-router-dom';
import { useContext } from 'react';
import DataContext from '../../context/DataContext';
import { Skeleton } from 'primereact/skeleton';
import { Paginator } from 'primereact/paginator';
import SearchToolBar from '../../components/buttonActions/SearchToolBar';
import { Dialog } from 'primereact/dialog';
import IncidentForm from '../../components/incident/IncidentForm';
import { createIncident } from '../../api/axiosIncidents';
import { getAllCountries } from '../../api/axiosCountries';
import { getCountryRegions} from '../../api/axiosRegions';
import { getRegionDistricts } from '../../api/axiosDistricts';
import { getDistrictWards } from '../../api/axiosWards';
import { getAllBroadCategories } from '../../api/axiosBroadCategories';
import { getBroadCategoryCategories } from '../../api/axiosCategories';
import { getCategorySubCategories } from '../../api/axiosSubCategories';
import { getBroadCategoryRights } from '../../api/axiosRights';
import { getAllEducationLevels } from '../../api/axiosEducationLevels';
import { getAllReligions } from '../../api/axiosReligions';
import { getAllVulnerabilities } from '../../api/axiosVulnerabilities';
import { getAllDisabilities } from '../../api/axiosDisabilities';
import { getAllMaritalStatuses } from '../../api/axiosMaritalStatuses';
import { getAllTribes } from '../../api/axiosTribes';
import { getAllEmploymentSectors } from '../../api/axiosEmploymentSectors';
import { getAllEmploymentStatuses } from '../../api/axiosEmploymentStatuses';
import { getAllMarriageTypes } from '../../api/axiosMarriageTypes';
import { getAllRoles } from '../../api/axiosRoles';
import { getAllZones } from '../../api/axiosZones';
import { getNotifications } from '../../api/axiosNotifications';
import ConfimUsers from '../../components/userconfirmation/ConfirmUsers';
import { Panel } from 'primereact/panel';









const MessageSubmissions = ({maincardtitlex}) => {
  
  const {
    messageSubmissions, setMessageSubmissions,
    fetcherror, setFetcherror,
    countries, setCountries,
    regions, setRegions,
    districts, setDistricts,
    wards, setWards,
    broadCategories, setBroadCategories,
    categories, setCategories,
    subCategories, setSubCategories,
    rights, setRights,
    religions, setReligions,
    tribes, setTribes,
    educationLevels, setEducationLevels,
    employmentStatuses, setEmploymentStatuses,
    employmentSectors, setEmploymentSectors,
    maritalStatuses, setMaritalStatuses,
    marriageTypes, setMarriageTypes,
    vulnerabilities, setVulnerabilities,
    disabilities, setDisabilities,
    roles,setRoles,auntheticatedUser,
    notifications, setNotifications,
    isLoadingNotifications, setIsLoadingNotifications,
    fetcherrorNotifications, setFetcherrorNotifications
  
  } = useContext(DataContext);


 
  const toast = useRef(null);
  const fileUploadRef = useRef(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const navigate = useNavigate()


  const [isLoading, setIsLoading] = useState(true);
  const [totalCount, setTotalCount] = useState(0);
  const [first, setFirst] = useState(0);
  const [rows, setRows] = useState(10);


  // Incident Edit.
  const fileBrowseOption1 = <span><i className="pi pi-upload" style={{ fontSize: '1rem' }}></i> &nbsp; Choose the File to Upload</span>
  const [editDialogVisible, setEditDialogVisible] = useState(false);
  const [fistNameReporter, setFistNameReporter] = useState("");
  const [lastNameReporter, setLastNameReporter] = useState("");
  const [selectedReporterRole,setSelectedReporterRole] = useState("");
  const [phoneReporter, setPhoneReporter] = useState("");
  const [emailReporter, setEmailReporter] = useState("");
  const [selectedSexReporter, setSelectedSexReporter] = useState("");

  const [incidentDescription, setIncidentDescription] = useState("");
  const [selectedCountry, setSelectedCountry] = useState("TANZANIA");
  const [selectedRegion, setSelectedRegion] = useState("");
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedWard, setSelectedWard] = useState("");
  const [street, setStreet] = useState("");
  const [eventDate, setEventDate] = useState("");
  const [selectedBroadCategory, setSelectedBroadCategory] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedRight, setSelectedRight] = useState("");
  const [stepsTaken, setStepsTaken] = useState(true);
  const [stepsDescription, setStepsDescription] = useState("");

  const [fistNameVictim, setFistNameVictim] = useState("");
  const [middleNameVictim, setMiddleNameVictim] = useState("");
  const [lastNameVictim, setLastNameVictim] = useState("");
  const [selectedSexVictim, setSelectSetSexVictim] = useState("");
  // const [emailVictim, setEmailVictim] = useState("");
  const [selectedBirthDayVictim, setSelectedBirthDayVictim] = useState("");
  const [selectedBirthMonthVictim, setSelectedBirthMonthVictim] = useState("");
  const [birthYearVictim, setBirthYearVictim] = useState("");
  const [phoneVictim, setPhoneVictim] = useState("");
  const [selectedEducationLevelVictim, setESelectedEducationLevelVictim] = useState("");
  const [selectedReligionVictim, setSelectedReligionVictim] = useState("");
  const [selectedTribeVictim, setSelectedTribeVictim] = useState("");
  const [childrenVictim, setChildrenVictim] = useState("");
  const [selectedMaritalStatusVictim, setSelectedMaritalStatusVictim] = useState("");
  const [selectedMarriageTypeVictim, setSelectedMarriageTypeVictim] = useState("");
  const [selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim] = useState("");
  const [selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim] = useState("");
  const [isVictimVulnerable, setIsVictimVulnerable] = useState(false);
  const [selectedVulnerabilityVictim, setSelectedVulnerabilityVictim] = useState("");
  const [isDisabled,setIsDisabled] = useState(false);
  const [selectedDisabilityVictim, setSelectedDisabilityVictim] = useState("");


  const [fullNamePerpetrator, setFullNamePerpetrator] = useState("");
  const [selectedSexPerpetrator, setSelectedSexPerpetrator] = useState("");
  const [phonePerpetrator, setPhonePerpetrator] = useState("");
  const [relationship, setRelationship] = useState("");
  const [assitanceNeeded, setAssitanceNeeded] = useState(false);
  const [assitanceDescription, setAssitanceDescription] = useState("");
  const [files, setFiles] = useState(null);
  const [zones, setZones] = useState([]);
  const [selectedZone, setSelectedZone] = useState("");
  const [messageSubmissionpkid, setMessageSubmissionpkid] = useState(null);
  const [disabledField, setDisabledField] = useState(false);
  

  
 
  const [incidentstatus, setIncidentstatus] = useState("");
  const [incidentValidity, setIncidentValidity] = useState(false);
  const EditDialogHeader = (<div className='text-center mb-0'>Process Incident</div>);
  const confirmUser = (<div className='text-center mb-0'>Map Incident to existing FOH</div>);
  const selectUserHeader = (<div className='text-center mb-0'>Select FOH </div>);

  const [userConfirmationDialog, setUserConfirmationDialog] = useState(false);
  const [mapUserDialog, setMapUserDialog] = useState(false);
  const [selectedMonitor, setSelectedMonitor] = useState(null);
  


  
  const createDaysArray =() => { 
    const daysArray = [];
      for (let i = 1; i <= 31; i++) {
        const dayValue = i < 10 ? "0" + i : "" + i;
        const dayObject = { day: dayValue, stringValue:dayValue };
        daysArray.push(dayObject);
    }
    return daysArray;
  }

  const daysArray = createDaysArray();


  const createMonthArray = () => {
    const monthsArray = [];
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    
    for (let i=0; i < 12; i++) { 
      let value;
      if (i < 9) { value = "0" + (i + 1); } else { value = (i+1).toString(); }
      let monthsObject = { month: months[i], stringValue: value }
      monthsArray.push(monthsObject);
    }
    return monthsArray;
  }

const monthsArray = createMonthArray();

  useEffect(() => {
    // getAllCountries(setCountries, setFetcherror);
    getAllCountries(setCountries, setFetcherror, (data, error) => {
      if (data) {
        setSelectedCountry(data?.find((c) => c.name === "TANZANIA"));
        getCountryRegions(setRegions, setFetcherror, (data?.find((c) => c.name === "TANZANIA"))?.id);
      }
      if(error){
        setFetcherror("Error: Could Not Fetch Countries");
      }
    });
    getAllBroadCategories(setBroadCategories, setFetcherror);
    getAllEducationLevels(setEducationLevels, setFetcherror);
    getAllReligions(setReligions, setFetcherror);
    getAllTribes(setTribes, setFetcherror);
    getAllMaritalStatuses(setMaritalStatuses, setFetcherror);
    getAllVulnerabilities(setVulnerabilities, setFetcherror);
    getAllDisabilities(setDisabilities, setFetcherror)
    getAllMarriageTypes(setMarriageTypes, setFetcherror);
    getAllEmploymentSectors(setEmploymentSectors, setFetcherror);
    getAllEmploymentStatuses(setEmploymentStatuses, setFetcherror);
    getAllRoles(setRoles, setFetcherror);
    getAllZones(setZones, setFetcherror);

    
  }, []);

  const handleOnEditSelectMessage = (tabledata) => { 
    setMessageSubmissionpkid(tabledata?.id);
    setPhoneReporter(tabledata?.phone);
    setIncidentDescription(tabledata?.content);
  }

  // const incidentTitle = <span className='p-5'>New Incident</span>;

  // const finalrolesArray = roles.map((role) => ({ ...role, name: (role?.name).substring(2) })).filter((item) => item?.name !== "Admin");
  const finalrolesArray = roles.filter((item) => item?.name !== "Admin");
  
  const handleSelectFile = (event) => {
      setFiles(event.files)
  }

  const handleRemoveFile = (event) => {
    const newFilesArray = files?.filter((xfile) => xfile.name !== event?.file?.name);
    setFiles(newFilesArray);
 }
  
  const handleFileUpload = (event) => {
    fileUploadRef.current.clear();
  };





  const handleUserConfirmation = (selectedUser) => {
      setFistNameReporter(selectedUser? selectedUser.firstname : "");
      setLastNameReporter(selectedUser? selectedUser.lastname : "");
      setPhoneReporter(selectedUser? selectedUser.phone : "");
      setEmailReporter(selectedUser ? selectedUser.email : "");
      setSelectedReporterRole(selectedUser? roles?.find((role) => role.name === selectedUser?.role): "");
      setSelectedSexReporter(selectedUser ? [{ id: 1, name: "MALE", namesw: "KIUME" }, { id: 2, name: "FEMALE", namesw: "KIKE" }].find((sex) => sex.name === selectedUser?.sex) : "");
      setDisabledField(selectedUser?.role === "Admin" ? "false" : "true");
      setSelectedMonitor(selectedUser);
      setEditDialogVisible(true);
    
       const autoSelectedCountry = countries?.find((country) => country.name === "TANZANIA");
       setSelectedCountry(autoSelectedCountry);
       getCountryRegions(setRegions, setFetcherror, autoSelectedCountry?.id);
    
  }

  const handleUserReset = () => {
    setFistNameReporter("");
    setLastNameReporter("");
    setPhoneReporter("");
    setEmailReporter("");
    setSelectedReporterRole("");
    setSelectedSexReporter("");
    setSelectedMonitor(null);
    // setSelectedCountry(null);
  }





  const operatorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false
  // const user_id = operatorinitiated? undefined: auntheticatedUser?.id;
 
  const hadleSubmit = () => {
    createIncident(
        fistNameReporter, setFistNameReporter,
        lastNameReporter, setLastNameReporter,
        selectedReporterRole,setSelectedReporterRole,
        phoneReporter, setPhoneReporter,
        emailReporter, setEmailReporter,
        selectedSexReporter, setSelectedSexReporter,
        incidentDescription, setIncidentDescription,
        selectedCountry, setSelectedCountry,
        selectedRegion, setSelectedRegion,
        selectedDistrict, setSelectedDistrict,
        selectedWard, setSelectedWard,
        street, setStreet,
        eventDate, setEventDate,
        selectedBroadCategory, setSelectedBroadCategory,
        selectedCategory, setSelectedCategory,
        selectedSubCategory, setSelectedSubCategory,
        selectedRight, setSelectedRight,
        stepsTaken, setStepsTaken,
        stepsDescription, setStepsDescription,
  
        fistNameVictim, setFistNameVictim,
        middleNameVictim, setMiddleNameVictim,
        lastNameVictim, setLastNameVictim,
        selectedSexVictim, setSelectSetSexVictim,
        selectedBirthDayVictim, setSelectedBirthDayVictim,
        selectedBirthMonthVictim, setSelectedBirthMonthVictim,
        birthYearVictim, setBirthYearVictim,
        phoneVictim, setPhoneVictim,
        selectedEducationLevelVictim, setESelectedEducationLevelVictim,
        selectedReligionVictim, setSelectedReligionVictim,
        selectedTribeVictim, setSelectedTribeVictim,
        childrenVictim, setChildrenVictim,
        selectedMaritalStatusVictim, setSelectedMaritalStatusVictim,
        selectedMarriageTypeVictim, setSelectedMarriageTypeVictim,
        selectedEmploymentStatusVictim, setSelectedEmploymentStatusVictim,
        selectedEmploymentSectorVictim, setSelectedEmploymentSectorVictim,
        isVictimVulnerable, setIsVictimVulnerable,
        selectedVulnerabilityVictim, setSelectedVulnerabilityVictim,
        isDisabled,setIsDisabled,
        selectedDisabilityVictim, setSelectedDisabilityVictim,
  
        fullNamePerpetrator, setFullNamePerpetrator,
        selectedSexPerpetrator, setSelectedSexPerpetrator,
        phonePerpetrator, setPhonePerpetrator,
        relationship, setRelationship,
        assitanceNeeded, setAssitanceNeeded,
        assitanceDescription, setAssitanceDescription,
        files, setFiles,incidentValidity,selectedMonitor?.id,
        setFetcherror,
        handleAllToasts,
        handleFileUpload,
        operatorinitiated,
        selectedZone, setSelectedZone,
        
      (err, data) => {
       
        if (data) {
          setEditDialogVisible(false);
         
          changeMessageSubmissionStatus(
            messageSubmissionpkid,
            true,
            false,
            undefined,
            setFetcherror,
            handleAllToasts,
            (err, data) => {
              if (data) {
                getNotifications(setNotifications, setIsLoadingNotifications, setFetcherrorNotifications, operatorinitiated ? undefined : auntheticatedUser.id);
                if (operatorinitiated) { getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror, setIsLoading, setFirst, setRows, undefined, setTotalCount, globalFilter, null); }
                else { getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror, setIsLoading, setFirst, setRows, undefined, setTotalCount, globalFilter, auntheticatedUser?.id); }
              }
            },
            selectedMonitor?.id
          )
        }
      }
    );
  }


 

   const handleInputChangeDBSearch = (value) => setGlobalFilter(value);
  
   useEffect(() => {
     const id = setTimeout(() => {
      if (operatorinitiated) { getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror, setIsLoading, setFirst, setRows, undefined, setTotalCount, globalFilter, null); }
      else { getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror, setIsLoading, setFirst, setRows, undefined, setTotalCount, globalFilter, auntheticatedUser?.id); }
     }, 1000);
     return () => clearTimeout(id);
   }, [globalFilter]);
   
 
  

  const handleAllToasts = (statusNum, msg) => {
    AllToasts(statusNum, msg, toast);
  };

  const extractTime = (timestamp) => { 
    const stamp = new Date(timestamp);
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const dateTime = `${stamp.getDate()} ${months[stamp.getMonth()]} ${stamp.getFullYear()}  ${stamp.getHours()}:${stamp.getMinutes()}`;
    return dateTime;
  }

  const onPageChange = (event) => {
    if (operatorinitiated) { getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror, setIsLoading, setFirst, setRows, event, setTotalCount, globalFilter, null); }
      else { getSpecificMessageSubmissions(setMessageSubmissions, setFetcherror, setIsLoading, setFirst, setRows, event, setTotalCount, globalFilter, auntheticatedUser?.id); }
  };
  
  const limitOptions = [5, 10, 20, 30, 50,100,200,500];
  const skeletonitems = Array.from({ length: 10 }, (v, i) => i);
  const maincardtitle= maincardtitlex ? maincardtitlex: (<div>Uprocessed Messages</div>);

  
  return (

    
    <div className="card">
      <Toast ref={toast} />
      
      <Card title={maincardtitle}>
            <SearchToolBar
                globalFilter={globalFilter}
                setGlobalFilter={setGlobalFilter}
                searchPlaceholder="Messages"
                handleInputChangeDBSearch={handleInputChangeDBSearch}
        
        />
        
        {!isLoading &&
          <DataTable
            value={messageSubmissions}
            showGridlines
            emptyMessage="No Messages found"
          >
            <Column header="S/N" body={(rowData) => messageSubmissions.indexOf(rowData)+1+ first}  style={{ width: '6%' }}> </Column>
            <Column header="Phone" body={(rowData) => rowData.phone} sortable></Column>
            <Column header="Content" body={(rowData) => rowData.content} sortable></Column>
          
            <Column className='w-10rem' header="Status" body={(rowData) => (
              <div className='flex flex-column'>
                <div className='text-color-secondary font-bold'>{(rowData.type === "sms") ? "SMS" : "WhatsApp"}</div>
                <div className='mt-2'><Tag severity="success" value="Unprocessed"></Tag></div>
                <div className='mt-2 text-sm'>{extractTime(rowData.createdAt)}</div>
              </div>)} >
                    
            </Column>
            
            {operatorinitiated &&  
            <Column header="Actions"  style={{ width: '5%' }} body={(rowData) => ( 
              <ProcessDiscard
                pkid={rowData.id}
                rowData={rowData}
                setFetcherror={setFetcherror}
                setSubmissions={setMessageSubmissions}
                handleAllToasts={handleAllToasts}
                submissionType="message"
                setEditDialogVisible={setMapUserDialog}
                handleOnEditSelectMessage={ handleOnEditSelectMessage}
                        
              />)}>
            </Column>
            }

            
          </DataTable>
        }
        {isLoading && 
          
          <DataTable value={skeletonitems} className="p-datatable-striped">
          <Column field="S/N" header="S/N" style={{ width: '6%' }} body={<Skeleton />}></Column>
          <Column field="Phone" header="Phone" style={{ width: '15%' }} body={<Skeleton />}sortable></Column>
          <Column field="Content" header="Content" style={{ width: '50%' }} body={<Skeleton />}sortable></Column>
          <Column field="Status" header="Status" style={{ width: '15%' }} body={<Skeleton />}></Column>
          <Column field="Actions" header="Actions" style={{ width: '5%' }} body={<Skeleton />}></Column>
          </DataTable>
          }

          {!isLoading &&
            <Paginator
              first={first}
              rows={rows}
              totalRecords={totalCount}
              rowsPerPageOptions={limitOptions}
              onPageChange={onPageChange}
            />
        } 
        
       
        
        
        
        <Dialog visible={editDialogVisible} modal header={EditDialogHeader} headerClassName='mb-0 pb-0' style={{ width: '80rem' }} onHide={() => { setEditDialogVisible(false); handleUserReset(); } }>
          <IncidentForm
              fistNameReporter = { fistNameReporter }          setFistNameReporter = { setFistNameReporter }
              lastNameReporter = { lastNameReporter }          setLastNameReporter = { setLastNameReporter }
              selectedReporterRole = {selectedReporterRole}    setSelectedReporterRole = {setSelectedReporterRole}
              phoneReporter = {phoneReporter}                  setPhoneReporter = {setPhoneReporter}
              emailReporter = {emailReporter}                  setEmailReporter = {setEmailReporter}
              selectedSexReporter = {selectedSexReporter}      setSelectedSexReporter = {setSelectedSexReporter}
              incidentDescription = {incidentDescription}      setIncidentDescription = {setIncidentDescription}
              selectedCountry = {selectedCountry}              setSelectedCountry = {setSelectedCountry}
              selectedRegion = {selectedRegion}                setSelectedRegion = {setSelectedRegion}
              selectedDistrict = {selectedDistrict}            setSelectedDistrict = {setSelectedDistrict}
              selectedWard = {selectedWard}                    setSelectedWard = {setSelectedWard}
              street = {street}                                setStreet = {setStreet}
              eventDate = {eventDate}                          setEventDate = {setEventDate}
              selectedBroadCategory = {selectedBroadCategory}  setSelectedBroadCategory = {setSelectedBroadCategory}
              selectedCategory = {selectedCategory}            setSelectedCategory = {setSelectedCategory}
              selectedSubCategory = {selectedSubCategory}      setSelectedSubCategory = {setSelectedSubCategory}
              selectedRight = {selectedRight}                  setSelectedRight = {setSelectedRight}
              stepsTaken = {stepsTaken}                        setStepsTaken = {setStepsTaken}
              stepsDescription = {stepsDescription}            setStepsDescription = {setStepsDescription}
                        
              fistNameVictim = {fistNameVictim}                setFistNameVictim = {setFistNameVictim}
              middleNameVictim = {middleNameVictim}            setMiddleNameVictim = {setMiddleNameVictim}
              lastNameVictim = {lastNameVictim}                setLastNameVictim = {setLastNameVictim}
              selectedSexVictim = {selectedSexVictim}          setSelectSetSexVictim = {setSelectSetSexVictim}
              selectedBirthDayVictim = {selectedBirthDayVictim} setSelectedBirthDayVictim = {setSelectedBirthDayVictim}
              selectedBirthMonthVictim = {selectedBirthMonthVictim} setSelectedBirthMonthVictim = {setSelectedBirthMonthVictim}
              birthYearVictim = {birthYearVictim}              setBirthYearVictim = {setBirthYearVictim}
              phoneVictim = {phoneVictim}                      setPhoneVictim = {setPhoneVictim}
              selectedEducationLevelVictim = {selectedEducationLevelVictim} setESelectedEducationLevelVictim = {setESelectedEducationLevelVictim}
              selectedReligionVictim = {selectedReligionVictim} setSelectedReligionVictim = {setSelectedReligionVictim}
              selectedTribeVictim = {selectedTribeVictim}       setSelectedTribeVictim = {setSelectedTribeVictim}
              childrenVictim = {childrenVictim}                 setChildrenVictim = {setChildrenVictim}
              selectedMaritalStatusVictim = {selectedMaritalStatusVictim} setSelectedMaritalStatusVictim = {setSelectedMaritalStatusVictim}
              selectedMarriageTypeVictim = {selectedMarriageTypeVictim} setSelectedMarriageTypeVictim = {setSelectedMarriageTypeVictim}
              selectedEmploymentStatusVictim = {selectedEmploymentStatusVictim} setSelectedEmploymentStatusVictim = {setSelectedEmploymentStatusVictim}
              selectedEmploymentSectorVictim = {selectedEmploymentSectorVictim} setSelectedEmploymentSectorVictim = {setSelectedEmploymentSectorVictim}
              isVictimVulnerable = {isVictimVulnerable}         setIsVictimVulnerable = {setIsVictimVulnerable}
              selectedVulnerabilityVictim = {selectedVulnerabilityVictim} setSelectedVulnerabilityVictim = {setSelectedVulnerabilityVictim}
              isDisabled = {isDisabled}                         setIsDisabled = {setIsDisabled}
              selectedDisabilityVictim = {selectedDisabilityVictim} setSelectedDisabilityVictim = {setSelectedDisabilityVictim}
              fullNamePerpetrator = {fullNamePerpetrator}       setFullNamePerpetrator = {setFullNamePerpetrator}
              selectedSexPerpetrator = {selectedSexPerpetrator} setSelectedSexPerpetrator = {setSelectedSexPerpetrator}
              phonePerpetrator = {phonePerpetrator}             setPhonePerpetrator = {setPhonePerpetrator}
              relationship = {relationship}                     setRelationship = {setRelationship}
              assitanceNeeded = {assitanceNeeded}               setAssitanceNeeded = {setAssitanceNeeded}
              assitanceDescription = {assitanceDescription}     setAssitanceDescription = {setAssitanceDescription}
              setFetcherror = {setFetcherror}                   tribes = {tribes}     
              handleFileUpload = {handleFileUpload}
                  hadleSubmit = {hadleSubmit}
              finalrolesArray = {finalrolesArray}               getCountryRegions = {getCountryRegions}
              setRegions = {setRegions}                         countries = {countries}
              getRegionDistricts = {getRegionDistricts}         setDistricts = {setDistricts}
              regions = {regions}                               getDistrictWards = {getDistrictWards}
              setWards = {setWards}                             districts = {districts}
              wards = {wards}                                   getBroadCategoryCategories = {getBroadCategoryCategories}
              setCategories = {setCategories}                   getBroadCategoryRights = {getBroadCategoryRights}
              setRights = {setRights}                           broadCategories = {broadCategories}
              getCategorySubCategories = {getCategorySubCategories} setSubCategories = {setSubCategories}
              categories = {categories}                         subCategories = {subCategories}
              rights = {rights}                                 daysArray = {daysArray}
              monthsArray = {monthsArray}                       educationLevels = {educationLevels}
              religions = {religions}                           maritalStatuses = {maritalStatuses}
              employmentStatuses = {employmentStatuses}         vulnerabilities = {vulnerabilities}
              marriageTypes = {marriageTypes}                   employmentSectors = {employmentSectors}
              disabilities = {disabilities}                     fileUploadRef = {fileUploadRef}
              handleSelectFile={handleSelectFile} handleRemoveFile={handleRemoveFile}
              validity={incidentValidity} setValidity={setIncidentValidity}
              setSelectedZone={setSelectedZone}
            zones={zones}
            disabledField={disabledField}
              />

               
        </Dialog>
        
      
          <Dialog visible={mapUserDialog} modal  style={{ width: '25rem' }} onHide={() => setMapUserDialog(false)}>
            <Panel header={confirmUser} headerClassName='mb-0 pb-0'>
                <div className="flex justify-content-end gap-3 mt-4">
                    <Button
                      label="No"
                      icon="pi pi-times"
                      outlined
                      className="px-4 py-2"
                      severity="primary"
                    onClick={() => {
                      setMapUserDialog(false);
                      setEditDialogVisible(true);
                      handleUserReset();
                    }}
                    />
                    
                    <Button
                      label="Yes"
                      className="px-4 py-2"
                      icon="pi pi-check"
                      severity="primary"
                      onClick={() => {
                      setUserConfirmationDialog(true);
                      setMapUserDialog(false);
                    }}
                    />
              </div> 

                </Panel>
                
          </Dialog>
        

        <Dialog visible={userConfirmationDialog} modal header={selectUserHeader} headerClassName='mb-0 pb-0' style={{ width: '60rem' }} onHide={() => setUserConfirmationDialog(false)}>
          <ConfimUsers
            setUserConfirmationDialog={setUserConfirmationDialog}
            userConfirmationDialog={userConfirmationDialog}
            handleUserConfirmation={handleUserConfirmation}
          />
        </Dialog>

      </Card>

   
    </div>
  )
}

export default MessageSubmissions